import mapData from "lib/stores/mapData";

function calculateZoomLevel(viewport, boundingBox, paddingFactor) {
  const { width, height } = viewport;
  const [minLng, minLat, maxLng, maxLat] = boundingBox;
  const lngDiff = maxLng - minLng;
  const latDiff = maxLat - minLat;

  const bufferedWidth = width / (1 + paddingFactor);
  const bufferedHeight = height / (1 + paddingFactor);

  const lngRatio = (360 * bufferedWidth) / (256 * lngDiff);
  const latRatio = (180 * bufferedHeight) / (256 * latDiff);

  const lngZoom = Math.log2(lngRatio);
  const latZoom = Math.log2(latRatio);

  return Math.min(lngZoom, latZoom);
}

function setZoomLevelForRegion(boundingBox, viewport, activeRegion) {
  let padding = 0.4;
  let multiplier = 1;
  if (window.innerWidth <= 1500) {
    padding = 0.0;
    if (activeRegion === 5) {
      multiplier = 1.1;
    }
    if (activeRegion === 4) {
      multiplier = 0.9;
    }
    if (activeRegion === 3) {
      multiplier = 0.9;
    }
    if (activeRegion === 2) {
      multiplier = 0.75;
    }
    if (activeRegion === 1) {
      multiplier = 1.1;
    }
  }
  const zoomLevel = calculateZoomLevel(viewport, boundingBox, padding) * multiplier;
  const [minLng, minLat, maxLng, maxLat] = boundingBox;
  const centerLng = (minLng + maxLng) / 2;
  const centerLat = (minLat + maxLat) / 2;

  return {
    ...viewport,
    latitude: centerLat,
    longitude: centerLng,
    zoom: zoomLevel
  };
}

export default function onChangeActiveRegion(activeRegion, selectedProduct, activeCountry, mapData, transitionDuration, linear, viewport) {
  if ((activeRegion && selectedProduct) || activeCountry) {
    return;
  }
  if (!viewport) return;

  if (!activeRegion) return;

  let bounds;

  switch (activeRegion as number | string) {
    // Asia
    case 1:
      // alert("Asia", activeRegion);
      bounds = [50.0, -70.0, 170.0, 71.0];
      break;
    // Africa
    case 2:
      // alert("Africa", activeRegion);
      bounds = [-17.532, -34.83, 51.415, 37.32];
      break;
    // Americas
    case 3:
      // alert("Americas", activeRegion);
      bounds = [-150.0, -70.0, -30.0, 85.0];
      break;
    // Europe
    case 4:
      // alert("Europe", activeRegion);
      bounds = [0.0, 33.0, 45.0, 72.0];
      break;
    // Arab States
    case 5:
      // alert("Arab States", activeRegion);
      bounds = [27.0, 2.0, 65.0, 50.0];
      break;
    // Oceania
    default:
      bounds = [110.0, -55.0, -170.0, 10.0];
  }

  const values = setZoomLevelForRegion(bounds, { width: viewport.width, height: viewport.height }, activeRegion);

  mapData.viewState = {
    ...mapData.viewState,
    transitionDuration,
    transitionInterpolator: linear,
    target: [0, 0, 0],
    minZoom: 0,
    pitch: 0,
    latitude: values.latitude,
    longitude: values.longitude,
    zoom: values.zoom
  };
}
